// extracted by mini-css-extract-plugin
module.exports = {"EqualColumnsTable":"styles_EqualColumnsTable__QmLS2"};